import React from 'react';
import PropTypes from 'prop-types';

export function StarIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.04894 0.927052C6.3483 0.0057416 7.6517 0.00574088 7.95106 0.927052L8.79611 3.52786C8.92999 3.93989 9.31394 4.21885 9.74717 4.21885H12.4818C13.4505 4.21885 13.8533 5.45846 13.0696 6.02786L10.8572 7.63525C10.5067 7.8899 10.3601 8.34127 10.494 8.75329L11.339 11.3541C11.6384 12.2754 10.5839 13.0415 9.80017 12.4721L7.58779 10.8647C7.2373 10.6101 6.7627 10.6101 6.41222 10.8647L4.19983 12.4721C3.41612 13.0415 2.36164 12.2754 2.66099 11.3541L3.50604 8.75329C3.63992 8.34127 3.49326 7.8899 3.14277 7.63525L0.930391 6.02787C0.146677 5.45846 0.549452 4.21885 1.51818 4.21885H4.25283C4.68606 4.21885 5.07001 3.93989 5.20389 3.52786L6.04894 0.927052Z"
        fill={color}
      />
    </svg>
  );
}
StarIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
StarIcon.defaultProps = {
  color: '#3B86F2',
  size: '0.972vw',
};
export function HalfStarIcon({ color, fillColor, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.064 2.29461L6.93861 6.60398L2.18334 7.29725C1.33058 7.42093 0.988822 8.47223 1.60724 9.07437L5.04757 12.4268L4.23386 17.1626C4.0874 18.0186 4.98898 18.6598 5.74409 18.2594L9.99813 16.0234L14.2522 18.2594C15.0073 18.6565 15.9089 18.0186 15.7624 17.1626L14.9487 12.4268L18.389 9.07437C19.0074 8.47223 18.6657 7.42093 17.8129 7.29725L13.0576 6.60398L10.9323 2.29461C10.5514 1.52648 9.44806 1.51671 9.064 2.29461Z"
        fill={fillColor}
      />
      <path
        d="M10.0004 1.71484C9.62925 1.71484 9.2581 1.90693 9.06602 2.29435L6.94008 6.60484L2.18357 7.29504C1.33059 7.41875 0.988744 8.47033 1.60732 9.07262L5.04854 12.4259L4.23463 17.1629C4.08813 18.0126 4.98343 18.6605 5.74525 18.2601L10.0004 16.0267V1.71484Z"
        fill={color}
      />
    </svg>
  );
}
HalfStarIcon.propTypes = {
  color: PropTypes.string,
  fillColor: PropTypes.string,
  size: PropTypes.string,
};
HalfStarIcon.defaultProps = {
  color: '#F2C94C',
  fillColor: '#E5E9F2',
  size: '20',
};
export function CallIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6335 15.1668C10.8802 15.1668 10.0868 14.9868 9.26683 14.6402C8.46683 14.3002 7.66016 13.8335 6.8735 13.2668C6.0935 12.6935 5.34016 12.0535 4.62683 11.3535C3.92016 10.6402 3.28016 9.88683 2.7135 9.1135C2.14016 8.3135 1.68016 7.5135 1.3535 6.74016C1.00683 5.9135 0.833496 5.1135 0.833496 4.36016C0.833496 3.84016 0.926829 3.34683 1.10683 2.88683C1.2935 2.4135 1.5935 1.9735 2.00016 1.5935C2.5135 1.08683 3.10016 0.833496 3.72683 0.833496C3.98683 0.833496 4.2535 0.893496 4.48016 1.00016C4.74016 1.12016 4.96016 1.30016 5.12016 1.54016L6.66683 3.72016C6.80683 3.9135 6.9135 4.10016 6.98683 4.28683C7.0735 4.48683 7.12016 4.68683 7.12016 4.88016C7.12016 5.1335 7.04683 5.38016 6.90683 5.6135C6.80683 5.7935 6.6535 5.98683 6.46016 6.18016L6.00683 6.6535C6.0135 6.6735 6.02016 6.68683 6.02683 6.70016C6.10683 6.84016 6.26683 7.08016 6.5735 7.44016C6.90016 7.8135 7.20683 8.1535 7.5135 8.46683C7.90683 8.8535 8.2335 9.16016 8.54016 9.4135C8.92016 9.7335 9.16683 9.8935 9.3135 9.96683L9.30016 10.0002L9.78683 9.52016C9.9935 9.3135 10.1935 9.16016 10.3868 9.06016C10.7535 8.8335 11.2202 8.7935 11.6868 8.98683C11.8602 9.06016 12.0468 9.16016 12.2468 9.30016L14.4602 10.8735C14.7068 11.0402 14.8868 11.2535 14.9935 11.5068C15.0935 11.7602 15.1402 11.9935 15.1402 12.2268C15.1402 12.5468 15.0668 12.8668 14.9268 13.1668C14.7868 13.4668 14.6135 13.7268 14.3935 13.9668C14.0135 14.3868 13.6002 14.6868 13.1202 14.8802C12.6602 15.0668 12.1602 15.1668 11.6335 15.1668ZM3.72683 1.8335C3.36016 1.8335 3.02016 1.9935 2.6935 2.3135C2.38683 2.60016 2.1735 2.9135 2.04016 3.2535C1.90016 3.60016 1.8335 3.96683 1.8335 4.36016C1.8335 4.98016 1.98016 5.6535 2.2735 6.34683C2.5735 7.0535 2.9935 7.78683 3.52683 8.52016C4.06016 9.2535 4.66683 9.96683 5.3335 10.6402C6.00016 11.3002 6.72016 11.9135 7.46016 12.4535C8.18016 12.9802 8.92016 13.4068 9.6535 13.7135C10.7935 14.2002 11.8602 14.3135 12.7402 13.9468C13.0802 13.8068 13.3802 13.5935 13.6535 13.2868C13.8068 13.1202 13.9268 12.9402 14.0268 12.7268C14.1068 12.5602 14.1468 12.3868 14.1468 12.2135C14.1468 12.1068 14.1268 12.0002 14.0735 11.8802C14.0535 11.8402 14.0135 11.7668 13.8868 11.6802L11.6735 10.1068C11.5402 10.0135 11.4202 9.94683 11.3068 9.90016C11.1602 9.84016 11.1002 9.78016 10.8735 9.92016C10.7402 9.98683 10.6202 10.0868 10.4868 10.2202L9.98016 10.7202C9.72016 10.9735 9.32016 11.0335 9.0135 10.9202L8.8335 10.8402C8.56016 10.6935 8.24016 10.4668 7.88683 10.1668C7.56683 9.8935 7.22016 9.5735 6.80016 9.16016C6.4735 8.82683 6.14683 8.4735 5.80683 8.08016C5.4935 7.7135 5.26683 7.40016 5.12683 7.14016L5.04683 6.94016C5.00683 6.78683 4.9935 6.70016 4.9935 6.60683C4.9935 6.36683 5.08016 6.1535 5.24683 5.98683L5.74683 5.46683C5.88016 5.3335 5.98016 5.20683 6.04683 5.0935C6.10016 5.00683 6.12016 4.9335 6.12016 4.86683C6.12016 4.8135 6.10016 4.7335 6.06683 4.6535C6.02016 4.54683 5.94683 4.42683 5.8535 4.30016L4.30683 2.1135C4.24016 2.02016 4.16016 1.9535 4.06016 1.90683C3.9535 1.86016 3.84016 1.8335 3.72683 1.8335ZM9.30016 10.0068L9.1935 10.4602L9.3735 9.9935C9.34016 9.98683 9.3135 9.9935 9.30016 10.0068Z"
        fill="#3B86F2"
      />
    </svg>
  );
}
export function WebsiteIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00016 15.1668C4.04683 15.1668 0.833496 11.9535 0.833496 8.00016C0.833496 4.04683 4.04683 0.833496 8.00016 0.833496C11.9535 0.833496 15.1668 4.04683 15.1668 8.00016C15.1668 11.9535 11.9535 15.1668 8.00016 15.1668ZM8.00016 1.8335C4.60016 1.8335 1.8335 4.60016 1.8335 8.00016C1.8335 11.4002 4.60016 14.1668 8.00016 14.1668C11.4002 14.1668 14.1668 11.4002 14.1668 8.00016C14.1668 4.60016 11.4002 1.8335 8.00016 1.8335Z"
        fill="#3B86F2"
      />
      <path
        d="M6.00016 14.5H5.33349C5.06016 14.5 4.83349 14.2733 4.83349 14C4.83349 13.7267 5.04682 13.5067 5.32016 13.5C4.27349 9.92667 4.27349 6.07333 5.32016 2.5C5.04682 2.49333 4.83349 2.27333 4.83349 2C4.83349 1.72667 5.06016 1.5 5.33349 1.5H6.00016C6.16016 1.5 6.31349 1.58 6.40682 1.70667C6.50016 1.84 6.52682 2.00667 6.47349 2.16C5.22016 5.92667 5.22016 10.0733 6.47349 13.8467C6.52682 14 6.50016 14.1667 6.40682 14.3C6.31349 14.42 6.16016 14.5 6.00016 14.5Z"
        fill="#3B86F2"
      />
      <path
        d="M10.0001 14.4998C9.94677 14.4998 9.89344 14.4931 9.8401 14.4731C9.5801 14.3865 9.43344 14.0998 9.52677 13.8398C10.7801 10.0731 10.7801 5.92646 9.52677 2.15313C9.4401 1.89313 9.5801 1.60646 9.8401 1.51979C10.1068 1.43313 10.3868 1.57313 10.4734 1.83313C11.8001 5.80646 11.8001 10.1798 10.4734 14.1465C10.4068 14.3665 10.2068 14.4998 10.0001 14.4998Z"
        fill="#3B86F2"
      />
      <path
        d="M8 11.4667C6.14 11.4667 4.28667 11.2067 2.5 10.68C2.49333 10.9467 2.27333 11.1667 2 11.1667C1.72667 11.1667 1.5 10.94 1.5 10.6667V10C1.5 9.84003 1.58 9.68669 1.70667 9.59336C1.84 9.50003 2.00667 9.47336 2.16 9.52669C5.92667 10.78 10.08 10.78 13.8467 9.52669C14 9.47336 14.1667 9.50003 14.3 9.59336C14.4333 9.68669 14.5067 9.84003 14.5067 10V10.6667C14.5067 10.94 14.28 11.1667 14.0067 11.1667C13.7333 11.1667 13.5133 10.9534 13.5067 10.68C11.7133 11.2067 9.86 11.4667 8 11.4667Z"
        fill="#3B86F2"
      />
      <path
        d="M14 6.50007C13.9467 6.50007 13.8934 6.4934 13.84 6.4734C10.0734 5.22007 5.92002 5.22007 2.15335 6.4734C1.88669 6.56007 1.60669 6.42007 1.52002 6.16007C1.44002 5.8934 1.58002 5.6134 1.84002 5.52674C5.81335 4.20007 10.1867 4.20007 14.1534 5.52674C14.4134 5.6134 14.56 5.90007 14.4667 6.16007C14.4067 6.36674 14.2067 6.50007 14 6.50007Z"
        fill="#3B86F2"
      />
    </svg>
  );
}
export function SMSIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3335 14.1668H4.66683C2.2335 14.1668 0.833496 12.7668 0.833496 10.3335V5.66683C0.833496 3.2335 2.2335 1.8335 4.66683 1.8335H11.3335C13.7668 1.8335 15.1668 3.2335 15.1668 5.66683V10.3335C15.1668 12.7668 13.7668 14.1668 11.3335 14.1668ZM4.66683 2.8335C2.76016 2.8335 1.8335 3.76016 1.8335 5.66683V10.3335C1.8335 12.2402 2.76016 13.1668 4.66683 13.1668H11.3335C13.2402 13.1668 14.1668 12.2402 14.1668 10.3335V5.66683C14.1668 3.76016 13.2402 2.8335 11.3335 2.8335H4.66683Z"
        fill={color}
      />
      <path
        d="M7.99969 8.57998C7.43969 8.57998 6.87302 8.40665 6.43969 8.05331L4.35302 6.38665C4.13969 6.21331 4.09969 5.89998 4.27302 5.68665C4.44636 5.47331 4.75969 5.43332 4.97303 5.60665L7.05969 7.27332C7.56635 7.67998 8.42635 7.67998 8.93302 7.27332L11.0197 5.60665C11.233 5.43332 11.553 5.46665 11.7197 5.68665C11.893 5.89998 11.8597 6.21998 11.6397 6.38665L9.55302 8.05331C9.12636 8.40665 8.55969 8.57998 7.99969 8.57998Z"
        fill={color}
      />
    </svg>
  );
}
SMSIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
SMSIcon.defaultProps = {
  color: '#3B86F2',
  size: '1.111vw',
};
export function ComboShape({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 0C19.067 0 17.5 1.567 17.5 3.5V7C17.5 8.933 19.067 10.5 21 10.5H24.5C26.433 10.5 28 8.933 28 7V3.5C28 1.567 26.433 0 24.5 0H21ZM3.5 17.5C1.567 17.5 0 19.067 0 21V24.5C0 26.433 1.567 28 3.5 28H7C8.933 28 10.5 26.433 10.5 24.5V21C10.5 19.067 8.933 17.5 7 17.5H3.5ZM0 3.5C0 1.567 1.567 0 3.5 0H7C8.933 0 10.5 1.567 10.5 3.5V7C10.5 8.933 8.933 10.5 7 10.5H3.5C1.567 10.5 0 8.933 0 7V3.5ZM21 17.5C19.067 17.5 17.5 19.067 17.5 21V24.5C17.5 26.433 19.067 28 21 28H24.5C26.433 28 28 26.433 28 24.5V21C28 19.067 26.433 17.5 24.5 17.5H21Z"
        fill={color}
      />
    </svg>
  );
}
ComboShape.propTypes = {
  color: PropTypes.string,
};
ComboShape.defaultProps = {
  color: '#4A5568',
};
export function LocationShape({ color }) {
  return (
    <svg
      width="32"
      height="36"
      viewBox="0 0 32 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 35.2715C21.9062 35.2715 31.75 24.4605 31.75 15.903C31.75 7.34546 24.6985 0.408203 16 0.408203C7.30151 0.408203 0.25 7.34546 0.25 15.903C0.25 24.4605 10.0938 35.2715 16 35.2715ZM16 21.3262C18.8995 21.3262 21.25 18.9848 21.25 16.0967C21.25 13.2085 18.8995 10.8672 16 10.8672C13.1005 10.8672 10.75 13.2085 10.75 16.0967C10.75 18.9848 13.1005 21.3262 16 21.3262Z"
        fill={color}
      />
    </svg>
  );
}
LocationShape.propTypes = {
  color: PropTypes.string,
};
LocationShape.defaultProps = {
  color: '#7D7D7D',
};
export function WalletIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 11.8999H7C6.59 11.8999 6.25 11.5599 6.25 11.1499C6.25 10.7399 6.59 10.3999 7 10.3999H13C13.41 10.3999 13.75 10.7399 13.75 11.1499C13.75 11.5599 13.41 11.8999 13 11.8999Z"
        fill="#3B86F2"
      />
      <path
        d="M2 11.8998C1.59 11.8998 1.25 11.5598 1.25 11.1498V6.52985C1.25 4.07985 3.24 2.08984 5.69 2.08984H11.31C13.88 2.08984 15.75 3.79984 15.75 6.14984C15.75 6.55984 15.41 6.89984 15 6.89984C14.59 6.89984 14.25 6.55984 14.25 6.14984C14.25 4.38984 12.72 3.58984 11.31 3.58984H5.69C4.07 3.58984 2.75 4.90985 2.75 6.52985V11.1498C2.75 11.5698 2.41 11.8998 2 11.8998Z"
        fill="#3B86F2"
      />
      <path
        d="M16 21.8999H6C3.38 21.8999 1.25 19.7699 1.25 17.1499V10.1499C1.25 7.5299 3.38 5.3999 6 5.3999H16C18.62 5.3999 20.75 7.5299 20.75 10.1499V11.5999C20.75 12.0099 20.41 12.3499 20 12.3499H18.92C18.57 12.3499 18.25 12.4798 18.02 12.7198L18.01 12.7299C17.68 13.0599 17.55 13.5198 17.67 13.9698C17.82 14.5298 18.41 14.9399 19.07 14.9399H20C20.41 14.9399 20.75 15.2799 20.75 15.6899V17.1399C20.75 19.7699 18.62 21.8999 16 21.8999ZM6 6.8999C4.21 6.8999 2.75 8.3599 2.75 10.1499V17.1499C2.75 18.9399 4.21 20.3999 6 20.3999H16C17.79 20.3999 19.25 18.9399 19.25 17.1499V16.4499H19.07C17.72 16.4499 16.55 15.5999 16.22 14.3699C15.96 13.3999 16.24 12.3699 16.95 11.6699C17.47 11.1399 18.17 10.8499 18.92 10.8499H19.25V10.1499C19.25 8.3599 17.79 6.8999 16 6.8999H6Z"
        fill="#3B86F2"
      />
      <path
        d="M20.9699 16.4501H19.0399C17.5299 16.4501 16.2499 15.3301 16.1299 13.8901C16.0499 13.0601 16.3499 12.2501 16.9499 11.6601C17.4499 11.1401 18.1599 10.8501 18.9099 10.8501H20.9599C21.9399 10.8501 22.7399 11.6401 22.7399 12.6201V14.6801C22.7499 15.6601 21.9499 16.4501 20.9699 16.4501ZM18.9199 12.3501C18.5699 12.3501 18.2499 12.4801 18.0199 12.7201C17.7299 13.0001 17.5899 13.3801 17.6299 13.7601C17.6799 14.4201 18.3199 14.9501 19.0399 14.9501H20.9699C21.1199 14.9501 21.2499 14.8301 21.2499 14.6801V12.6201C21.2499 12.4701 21.1199 12.3501 20.9699 12.3501H18.9199Z"
        fill="#3B86F2"
      />
    </svg>
  );
}
export function HambargerIcon() {
  return (
    <svg
      width="2.917vw"
      height="2.986vw"
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.75 10.1074H5.25C4.5325 10.1074 3.9375 9.51242 3.9375 8.79492C3.9375 8.07742 4.5325 7.48242 5.25 7.48242H36.75C37.4675 7.48242 38.0625 8.07742 38.0625 8.79492C38.0625 9.51242 37.4675 10.1074 36.75 10.1074Z"
        fill="#7D7D7D"
      />
      <path
        d="M36.75 18.8574H5.25C4.5325 18.8574 3.9375 18.2624 3.9375 17.5449C3.9375 16.8274 4.5325 16.2324 5.25 16.2324H36.75C37.4675 16.2324 38.0625 16.8274 38.0625 17.5449C38.0625 18.2624 37.4675 18.8574 36.75 18.8574Z"
        fill="#7D7D7D"
      />
      <path
        d="M36.75 27.6074H5.25C4.5325 27.6074 3.9375 27.0124 3.9375 26.2949C3.9375 25.5774 4.5325 24.9824 5.25 24.9824H36.75C37.4675 24.9824 38.0625 25.5774 38.0625 26.2949C38.0625 27.0124 37.4675 27.6074 36.75 27.6074Z"
        fill="#7D7D7D"
      />
      <path
        d="M36.75 36.3574H5.25C4.5325 36.3574 3.9375 35.7624 3.9375 35.0449C3.9375 34.3274 4.5325 33.7324 5.25 33.7324H36.75C37.4675 33.7324 38.0625 34.3274 38.0625 35.0449C38.0625 35.7624 37.4675 36.3574 36.75 36.3574Z"
        fill="#7D7D7D"
      />
    </svg>
  );
}
export function SliderArrowRight({ color }) {
  return (
    <svg
      width="71"
      height="90"
      viewBox="0 0 71 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_372_13679)">
        <path
          d="M50.2417 13.8889C50.3031 12.5096 51.471 11.4411 52.8503 11.5025C54.2297 11.5638 55.2981 12.7317 55.2368 14.1111L50.2417 13.8889ZM17.3558 64.9253C16.0217 64.5694 15.2288 63.1994 15.5847 61.8653L21.3848 40.1258C21.7407 38.7917 23.1107 37.9988 24.4447 38.3547C25.7788 38.7106 26.5717 40.0806 26.2158 41.4147L21.0602 60.7387L40.3843 65.8944C41.7183 66.2503 42.5112 67.6203 42.1553 68.9543C41.7994 70.2884 40.4294 71.0813 39.0954 70.7254L17.3558 64.9253ZM55.2368 14.1111C54.5976 28.4827 51.3054 38.0077 45.0805 45.5814C38.9657 53.0211 30.1801 58.3489 19.2526 64.6735L16.7479 60.3461C27.8123 53.9422 35.7727 49.0314 41.2178 42.4066C46.5527 35.9157 49.6341 27.5501 50.2417 13.8889L55.2368 14.1111Z"
          fill={color !== '' ? color : '#C9C9C9'}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_372_13679"
          x="0.499512"
          y="0.5"
          width="69.7397"
          height="89.3105"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_372_13679"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_372_13679"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
SliderArrowRight.propTypes = {
  color: PropTypes.string,
};
SliderArrowRight.defaultProps = {
  color: '',
};
export function SliderArrowLeft({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 82 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_372_13678)">
        <path
          d="M20.5927 13.2528C20.1801 11.9352 18.7774 11.2016 17.4598 11.6143C16.1422 12.027 15.4086 13.4296 15.8213 14.7472L20.5927 13.2528ZM65.448 54.1702C66.6466 53.4849 67.0627 51.9576 66.3773 50.759L55.2083 31.2269C54.5229 30.0283 52.9957 29.6122 51.7971 30.2976C50.5985 30.983 50.1824 32.5103 50.8678 33.7089L60.7958 51.0708L43.4339 60.9987C42.2353 61.6841 41.8193 63.2114 42.5047 64.41C43.19 65.6085 44.7173 66.0246 45.9159 65.3392L65.448 54.1702ZM15.8213 14.7472C20.1206 28.4737 25.7422 36.8372 33.6981 42.565C41.5133 48.1915 51.3689 51.0939 63.55 54.4121L64.8641 49.5879C52.5305 46.2281 43.579 43.5177 36.6194 38.5072C29.8005 33.598 24.6795 26.3006 20.5927 13.2528L15.8213 14.7472Z"
          fill={color !== '' ? color : '#C9C9C9'}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_372_13678"
          x="0.706543"
          y="0.499512"
          width="81.001"
          height="84.1699"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_372_13678"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_372_13678"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
SliderArrowLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
SliderArrowLeft.defaultProps = {
  color: '',
  size: '5.903vw',
};
export function EntityIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.29165 13.7708H2.37998C1.46415 13.7708 0.711647 13.0358 0.711647 12.1258V3.46917C0.711647 2.57667 1.04415 1.88251 1.65081 1.50334C2.26331 1.11834 3.05665 1.13001 3.87915 1.53834L6.46915 2.81001C7.17498 3.16001 7.72915 4.04084 7.72915 4.82251V13.3333C7.72915 13.5725 7.53081 13.7708 7.29165 13.7708ZM2.65998 2.10417C2.45581 2.10417 2.26915 2.15084 2.11165 2.25001C1.77331 2.46001 1.58665 2.89751 1.58665 3.46917V12.1258C1.58665 12.5517 1.94248 12.8958 2.37998 12.8958H6.85415V4.82251C6.85415 4.37334 6.49248 3.79584 6.07831 3.59751L3.48831 2.32584C3.19081 2.18001 2.91081 2.10417 2.65998 2.10417Z"
        fill={color}
      />
      <path
        d="M10.9725 13.7708H7.29166C7.0525 13.7708 6.85416 13.5725 6.85416 13.3333V6.57833C6.85416 6.44416 6.9125 6.32166 7.0175 6.23999C7.1225 6.15833 7.25083 6.12333 7.385 6.15249L7.65916 6.21083L11.4742 7.06249C12.635 7.31916 13.2183 8.00166 13.2533 9.16249C13.2592 9.16249 13.2592 9.22083 13.2592 9.28499V11.49C13.2533 12.9833 12.4658 13.7708 10.9725 13.7708ZM7.72916 12.8958H10.9725C11.9992 12.8958 12.3783 12.5167 12.3783 11.49V9.23833C12.3492 8.43916 12.0458 8.08333 11.2817 7.91416L7.72916 7.12083V12.8958Z"
        fill={color}
      />
      <path
        d="M5.2325 6.1875H3.20834C2.96917 6.1875 2.77084 5.98917 2.77084 5.75C2.77084 5.51083 2.96917 5.3125 3.20834 5.3125H5.2325C5.47167 5.3125 5.67 5.51083 5.67 5.75C5.67 5.98917 5.4775 6.1875 5.2325 6.1875Z"
        fill={color}
      />
      <path
        d="M5.2325 8.52081H3.20834C2.96917 8.52081 2.77084 8.32248 2.77084 8.08331C2.77084 7.84415 2.96917 7.64581 3.20834 7.64581H5.2325C5.47167 7.64581 5.67 7.84415 5.67 8.08331C5.67 8.32248 5.4775 8.52081 5.2325 8.52081Z"
        fill={color}
      />
      <path
        d="M8.87832 10.8542C7.91582 10.8542 7.12832 10.0667 7.12832 9.1042V6.6367C7.12832 6.50253 7.18665 6.38003 7.29165 6.29253C7.39665 6.20503 7.53082 6.17586 7.65915 6.20503L10.2842 6.7942C10.4825 6.84086 10.6283 7.01586 10.6283 7.22003V9.09836C10.6283 10.0667 9.84665 10.8542 8.87832 10.8542ZM8.00332 7.18503V9.1042C8.00332 9.58836 8.39415 9.9792 8.87832 9.9792C9.36249 9.9792 9.75332 9.58836 9.75332 9.1042V7.57586L8.00332 7.18503Z"
        fill={color}
      />
      <path
        d="M11.5033 10.8542C10.5408 10.8542 9.75332 10.0667 9.75332 9.10418V7.22585C9.75332 7.09168 9.81165 6.96918 9.91665 6.88751C10.0217 6.80585 10.1558 6.77085 10.2842 6.80001L11.4683 7.06251C12.6292 7.31918 13.2125 8.00168 13.2475 9.16251C13.2475 9.17418 13.2475 9.18585 13.2475 9.19751C13.2008 10.125 12.4367 10.8542 11.5033 10.8542ZM10.6283 7.76835V9.10418C10.6283 9.58835 11.0192 9.97918 11.5033 9.97918C11.9642 9.97918 12.3433 9.62335 12.3725 9.16835C12.3433 8.43335 12.04 8.08335 11.2817 7.91418L10.6283 7.76835Z"
        fill={color}
      />
    </svg>
  );
}
EntityIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
EntityIcon.defaultProps = {
  color: '#ffffff',
  size: '0.972vw',
};
export function TransferIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00016 0.333008C3.32016 0.333008 0.333496 3.31967 0.333496 6.99967C0.333496 10.6797 3.32016 13.6663 7.00016 13.6663C10.6802 13.6663 13.6668 10.6797 13.6668 6.99967C13.6668 3.31967 10.6802 0.333008 7.00016 0.333008ZM10.4602 9.62634C10.4335 9.68634 10.4002 9.73967 10.3535 9.78634L9.22683 10.913C9.12683 11.013 9.00016 11.0597 8.8735 11.0597C8.74683 11.0597 8.62016 11.013 8.52016 10.913C8.32683 10.7197 8.32683 10.3997 8.52016 10.2063L8.7935 9.93301H5.06683C4.20016 9.93301 3.50016 9.22634 3.50016 8.36634V7.18634C3.50016 6.91301 3.72683 6.68634 4.00016 6.68634C4.2735 6.68634 4.50016 6.91301 4.50016 7.18634V8.36634C4.50016 8.67967 4.7535 8.93301 5.06683 8.93301H8.7935L8.52016 8.65967C8.32683 8.46634 8.32683 8.14634 8.52016 7.95301C8.7135 7.75967 9.0335 7.75967 9.22683 7.95301L10.3535 9.07967C10.4002 9.12634 10.4335 9.17967 10.4602 9.23967C10.5135 9.36634 10.5135 9.50634 10.4602 9.62634ZM10.5002 6.81301C10.5002 7.08634 10.2735 7.31301 10.0002 7.31301C9.72683 7.31301 9.50016 7.08634 9.50016 6.81301V5.63301C9.50016 5.31967 9.24683 5.06634 8.9335 5.06634H5.20683L5.48016 5.33301C5.6735 5.52634 5.6735 5.84634 5.48016 6.03967C5.38016 6.13967 5.2535 6.18634 5.12683 6.18634C5.00016 6.18634 4.8735 6.13967 4.7735 6.03967L3.64683 4.91301C3.60016 4.86634 3.56683 4.81301 3.54016 4.75301C3.48683 4.63301 3.48683 4.49301 3.54016 4.37301C3.56683 4.31301 3.60016 4.25301 3.64683 4.20634L4.7735 3.07967C4.96683 2.88634 5.28683 2.88634 5.48016 3.07967C5.6735 3.27301 5.6735 3.59301 5.48016 3.78634L5.20683 4.05967H8.9335C9.80016 4.05967 10.5002 4.76634 10.5002 5.62634V6.81301Z"
        fill={color}
      />
    </svg>
  );
}
TransferIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
TransferIcon.defaultProps = {
  color: '#603ACB',
  size: '0.972vw',
};
export function AddIcon({ marginRight }) {
  return (
    <svg
      width="0.694vw"
      height="0.694vw"
      viewBox="0 0 9 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight }}
    >
      <path
        d="M3.87524 4.37842V0.628418H5.12525V4.37842H8.87525V5.62842H5.12525V9.37842H3.87524V5.62842H0.125244V4.37842H3.87524Z"
        fill="white"
      />
    </svg>
  );
}
AddIcon.propTypes = {
  marginRight: PropTypes.string,
};
AddIcon.defaultProps = {
  marginRight: '',
};
export function EditIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.864 3.84304L6.157 3.13604L1.5 7.79304V8.50004H2.207L6.864 3.84304ZM7.571 3.13604L8.278 2.42904L7.571 1.72204L6.864 2.42904L7.571 3.13604ZM2.621 9.50004H0.5V7.37854L7.2175 0.661042C7.31126 0.567306 7.43842 0.514648 7.571 0.514648C7.70358 0.514648 7.83074 0.567306 7.9245 0.661042L9.339 2.07554C9.43274 2.16931 9.48539 2.29646 9.48539 2.42904C9.48539 2.56162 9.43274 2.68878 9.339 2.78254L2.6215 9.50004H2.621Z"
        fill={color}
      />
    </svg>
  );
}
EditIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
EditIcon.defaultProps = {
  color: '#0288FA',
  size: '0.694vw',
};
export function NoContact() {
  return (
    <svg
      width="467"
      height="362"
      viewBox="0 0 467 362"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="467" height="362" fill="white" />
      <g filter="url(#filter0_f_5958_71186)">
        <ellipse
          cx="225.607"
          cy="266.338"
          rx="110.607"
          ry="21.3375"
          fill="#1F88F8"
          fillOpacity="0.35"
        />
      </g>
      <path
        d="M229.701 292.402C293.049 292.402 344.402 241.049 344.402 177.701C344.402 114.353 293.049 63 229.701 63C166.354 63 115 114.353 115 177.701C115 241.049 166.354 292.402 229.701 292.402Z"
        fill="url(#paint0_linear_5958_71186)"
      />
      <path
        d="M318.433 109.366H172.743V181.262H318.433V109.366Z"
        fill="url(#paint1_linear_5958_71186)"
      />
      <path
        d="M318.433 109.366H333.056C342.589 109.366 351.731 113.153 358.472 119.893C365.213 126.634 369 135.777 369 145.31C369 154.843 365.213 163.985 358.472 170.726C351.731 177.467 342.589 181.254 333.056 181.254H318.433V109.366Z"
        fill="url(#paint2_linear_5958_71186)"
      />
      <path
        d="M327.891 119.942H336.257C342.691 119.942 348.861 122.498 353.41 127.047C357.96 131.596 360.516 137.767 360.516 144.201V146.428C360.516 152.862 357.96 159.032 353.41 163.581C348.861 168.131 342.691 170.687 336.257 170.687H327.891V119.942Z"
        fill="url(#paint3_linear_5958_71186)"
      />
      <path
        d="M318.433 121.432H184.978V181.262H318.433V121.432Z"
        fill="url(#paint4_linear_5958_71186)"
      />
      <rect
        x="137.934"
        y="193.231"
        width="54.1073"
        height="69.2953"
        fill="url(#paint5_linear_5958_71186)"
      />
      <rect
        x="204.382"
        y="193.231"
        width="54.1073"
        height="69.2953"
        fill="url(#paint6_linear_5958_71186)"
      />
      <rect
        x="270.83"
        y="193.231"
        width="35.1223"
        height="69.2953"
        fill="url(#paint7_linear_5958_71186)"
      />
      <path
        d="M318.433 109.366H305.994V181.262H318.433V109.366Z"
        fill="url(#paint8_linear_5958_71186)"
      />
      <path
        d="M204.382 180.891L192.042 180.891L192.042 274.867L204.382 274.867L204.382 180.891Z"
        fill="url(#paint9_linear_5958_71186)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M130.34 180.891L138.463 180.891L138.463 274.867H130.34C127.719 274.867 125.594 272.742 125.594 270.121L125.594 185.637C125.594 183.016 127.719 180.891 130.34 180.891ZM264.185 193.231V180.891H138.463V193.231H264.185ZM264.185 274.867V262.527H138.463V274.867H264.185Z"
        fill="url(#paint10_linear_5958_71186)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M270.83 180.891H263.236C260.614 180.891 258.49 183.016 258.49 185.637L258.49 274.867H270.83V274.867H305.952L305.952 274.867H313.546C316.167 274.867 318.292 272.742 318.292 270.121L318.292 180.891L305.952 180.891H270.83ZM305.952 193.231H270.83L270.83 262.527H305.952V193.231Z"
        fill="url(#paint11_linear_5958_71186)"
      />
      <path
        d="M182.506 181.415V181.55V185.826V216.978H216.502C217.026 216.978 217.451 216.553 217.451 216.029V185.826V182.364C217.451 181.84 217.026 181.415 216.502 181.415H182.506Z"
        fill="url(#paint12_linear_5958_71186)"
      />
      <path
        d="M180.449 181.415C179.925 181.415 179.5 181.84 179.5 182.364V216.029C179.5 216.553 179.925 216.978 180.449 216.978H214.445V181.415H180.449Z"
        fill="url(#paint13_linear_5958_71186)"
      />
      <path
        d="M208.617 184.819H185.336C184.287 184.819 183.437 185.669 183.437 186.717V211.387C183.437 212.436 184.287 213.286 185.336 213.286H208.617C209.666 213.286 210.516 212.436 210.516 211.387V186.717C210.516 185.669 209.666 184.819 208.617 184.819Z"
        fill="url(#paint14_linear_5958_71186)"
      />
      <g filter="url(#filter1_d_5958_71186)">
        <path
          d="M118 157.347L131.142 189.667C131.321 190.11 131.586 190.514 131.922 190.854C132.258 191.194 132.657 191.465 133.098 191.651C133.538 191.836 134.011 191.933 134.489 191.936C134.967 191.938 135.441 191.847 135.883 191.666L165.333 179.701C166.228 179.337 166.943 178.632 167.319 177.741C167.695 176.851 167.703 175.847 167.34 174.951L152.149 137.593C151.785 136.7 151.081 135.987 150.192 135.613C149.303 135.238 148.301 135.232 147.407 135.595L122.937 145.544L118 157.347Z"
          fill="url(#paint15_linear_5958_71186)"
        />
      </g>
      <g filter="url(#filter2_d_5958_71186)">
        <path
          d="M326.132 138.362L312.991 170.682C312.811 171.125 312.546 171.529 312.21 171.869C311.875 172.209 311.475 172.48 311.035 172.666C310.594 172.851 310.121 172.948 309.643 172.951C309.165 172.953 308.691 172.861 308.249 172.681L278.799 160.716C277.904 160.352 277.19 159.647 276.813 158.756C276.437 157.866 276.43 156.862 276.793 155.966L291.983 118.608C292.347 117.714 293.051 117.002 293.941 116.628C294.83 116.253 295.831 116.246 296.725 116.61L321.196 126.559L326.132 138.362Z"
          fill="url(#paint16_linear_5958_71186)"
        />
      </g>
      <path
        d="M118 157.347L126.358 153.952L122.945 145.544L118 157.347Z"
        fill="url(#paint17_linear_5958_71186)"
      />
      <path
        d="M326.132 138.362L317.775 134.967L321.187 126.559L326.132 138.362Z"
        fill="url(#paint18_linear_5958_71186)"
      />
      <path
        d="M277.155 104.192C277.155 105.524 276.955 106.848 276.562 108.121C275.926 110.162 274.801 112.016 273.285 113.523C272.84 113.974 272.362 114.39 271.854 114.768C271.52 115.028 271.17 115.266 270.804 115.479C270.44 115.703 270.064 115.906 269.678 116.089C269.102 116.373 268.505 116.611 267.891 116.8C266.619 117.193 265.294 117.393 263.962 117.393H261.507V181.025H192.921V102.812C192.932 99.6828 194.18 96.6848 196.393 94.4721C198.606 92.2593 201.604 91.0113 204.733 91.0001H263.929C265.578 90.9938 267.213 91.3012 268.747 91.9061C269.172 92.0711 269.588 92.2605 269.991 92.4734C270.194 92.575 270.389 92.6851 270.584 92.8036C270.744 92.8915 270.9 92.9876 271.05 93.0915C271.85 93.5975 272.591 94.1911 273.26 94.8612C274.157 95.7609 274.922 96.7845 275.529 97.901C275.939 98.6534 276.274 99.4448 276.528 100.263L276.706 100.898C276.815 101.323 276.903 101.752 276.968 102.186C277.082 102.849 277.145 103.52 277.155 104.192Z"
        fill="url(#paint19_linear_5958_71186)"
      />
      <path
        d="M277.155 104.192C277.155 105.524 276.955 106.848 276.562 108.121C276.302 108.938 275.968 109.728 275.563 110.483C274.95 111.598 274.183 112.622 273.285 113.523C272.84 113.974 272.362 114.39 271.854 114.768C271.516 115.022 271.168 115.251 270.804 115.479C270.44 115.702 270.064 115.906 269.678 116.089C269.101 116.369 268.504 116.607 267.891 116.8C266.619 117.193 265.294 117.393 263.963 117.393H261.507V102.812C261.512 100.48 262.205 98.202 263.499 96.2621C264.793 94.3223 266.63 92.807 268.781 91.906C269.204 92.0754 269.627 92.2616 270.025 92.4733C270.228 92.5749 270.423 92.685 270.618 92.8035C270.778 92.8914 270.934 92.9875 271.084 93.0914C271.884 93.5974 272.625 94.191 273.294 94.8611C274.191 95.7608 274.956 96.7844 275.563 97.9009C275.97 98.655 276.304 99.446 276.562 100.263L276.74 100.898C276.85 101.322 276.938 101.752 277.002 102.185C277.105 102.849 277.156 103.52 277.155 104.192Z"
        fill="url(#paint20_linear_5958_71186)"
      />
      <path
        d="M247.815 157.858H204.504C203.779 157.858 203.192 158.444 203.192 159.167C203.192 159.889 203.779 160.475 204.504 160.475H247.815C248.54 160.475 249.127 159.889 249.127 159.167C249.127 158.444 248.54 157.858 247.815 157.858Z"
        fill="#AACCE9"
      />
      <path
        d="M247.815 144.438H204.504C203.779 144.438 203.192 145.023 203.192 145.746C203.192 146.468 203.779 147.054 204.504 147.054H247.815C248.54 147.054 249.127 146.468 249.127 145.746C249.127 145.023 248.54 144.438 247.815 144.438Z"
        fill="#AACCE9"
      />
      <path
        d="M247.815 131.008H219.923C219.198 131.008 218.611 131.594 218.611 132.317C218.611 133.039 219.198 133.625 219.923 133.625H247.815C248.539 133.625 249.127 133.039 249.127 132.317C249.127 131.594 248.539 131.008 247.815 131.008Z"
        fill="#AACCE9"
      />
      <path
        d="M229.517 117.579H204.199C203.643 117.579 203.192 118.03 203.192 118.587V119.188C203.192 119.744 203.643 120.196 204.199 120.196H229.517C230.073 120.196 230.524 119.744 230.524 119.188V118.587C230.524 118.03 230.073 117.579 229.517 117.579Z"
        fill="#AACCE9"
      />
      <path
        d="M213.818 131.008H204.504C203.779 131.008 203.192 131.594 203.192 132.317C203.192 133.039 203.779 133.625 204.504 133.625H213.818C214.543 133.625 215.131 133.039 215.131 132.317C215.131 131.594 214.543 131.008 213.818 131.008Z"
        fill="#AACCE9"
      />
      <path
        d="M138.409 193.231H142.681V262.527H138.409V193.231Z"
        fill="url(#paint21_linear_5958_71186)"
      />
      <path
        d="M204.382 216.962H208.179V262.526H204.382V216.962Z"
        fill="url(#paint22_linear_5958_71186)"
      />
      <path
        d="M270.83 193.231H275.102V262.527H270.83V193.231Z"
        fill="url(#paint23_linear_5958_71186)"
      />
      <g filter="url(#filter3_f_5958_71186)">
        <ellipse
          cx="154.579"
          cy="134.757"
          rx="36.5786"
          ry="11.7574"
          fill="#FF4C77"
          fillOpacity="0.3"
        />
      </g>
      <path
        d="M120.278 117.624C120.984 122.891 123.012 127.893 126.173 132.164C129.334 136.435 133.526 139.836 138.357 142.05C143.188 144.263 148.5 145.216 153.799 144.821C159.099 144.426 164.211 142.696 168.661 139.791L180.783 143.912C181.149 144.032 181.541 144.045 181.914 143.95C182.287 143.854 182.625 143.654 182.888 143.373C183.15 143.091 183.327 142.74 183.397 142.362C183.466 141.983 183.426 141.592 183.281 141.236L178.419 129.64C181.005 125.332 182.521 120.468 182.841 115.455C183.161 110.441 182.275 105.424 180.258 100.823C178.24 96.222 175.15 92.1712 171.246 89.0096C167.342 85.848 162.738 83.6676 157.818 82.6509C152.898 81.6341 147.806 81.8107 142.969 83.1658C138.131 84.5208 133.689 87.015 130.013 90.4395C126.337 93.8639 123.535 98.119 121.842 102.849C120.148 107.578 119.612 112.645 120.278 117.624Z"
        fill="url(#paint24_linear_5958_71186)"
      />
      <path
        d="M150.629 129.545C154.044 129.545 156.477 127.206 156.477 123.931C156.477 120.656 154.044 118.316 150.629 118.316C147.26 118.316 144.781 120.656 144.781 123.931C144.781 127.206 147.26 129.545 150.629 129.545ZM155.307 117.381C155.307 114.293 157.085 113.17 159.518 112.047C162.746 110.55 165.132 107.509 165.132 103.766C165.132 97.8711 159.331 93.7539 151.471 93.7539C143.049 93.7539 137.108 98.4793 136.593 105.076L147.354 107.041C147.634 104.468 148.991 102.643 150.909 102.643C152.36 102.643 153.436 103.626 153.436 104.982C153.436 106.573 151.845 107.556 150.582 108.304C147.213 110.503 145.95 112.936 145.95 117.381H155.307Z"
        fill="white"
      />
      <path
        d="M307.887 95.0964C307.887 97.7419 305.742 99.8865 303.097 99.8865C300.451 99.8865 298.307 97.7419 298.307 95.0964C298.307 92.451 300.451 90.3064 303.097 90.3064C305.742 90.3064 307.887 92.451 307.887 95.0964Z"
        fill="url(#paint25_linear_5958_71186)"
        stroke="url(#paint26_linear_5958_71186)"
        strokeWidth="2.61276"
      />
      <circle
        cx="275.097"
        cy="286.096"
        r="4.79006"
        fill="url(#paint27_linear_5958_71186)"
        stroke="url(#paint28_linear_5958_71186)"
        strokeWidth="2.61276"
      />
      <path
        d="M114.031 224.236C115.355 224.024 116.412 225.325 115.934 226.577L112.705 235.033C112.227 236.285 110.572 236.55 109.726 235.51L104.018 228.486C103.172 227.445 103.77 225.879 105.094 225.667L114.031 224.236Z"
        fill="url(#paint29_linear_5958_71186)"
      />
      <path
        d="M334.978 217.006C334.647 215.707 335.847 214.536 337.137 214.899L345.851 217.348C347.142 217.71 347.556 219.335 346.596 220.271L340.119 226.593C339.159 227.529 337.546 227.076 337.214 225.777L334.978 217.006Z"
        fill="url(#paint30_linear_5958_71186)"
      />
      <path
        d="M218.87 57.4171C219.385 55.2841 222.419 55.2841 222.934 57.4171L224.667 64.5959C224.851 65.3582 225.446 65.9533 226.208 66.1373L233.387 67.8702C235.52 68.3851 235.52 71.419 233.387 71.9339L226.208 73.6668C225.446 73.8508 224.851 74.446 224.667 75.2082L222.934 82.387C222.419 84.52 219.385 84.52 218.87 82.387L217.138 75.2082C216.954 74.446 216.358 73.8508 215.596 73.6668L208.417 71.9339C206.284 71.419 206.284 68.3851 208.417 67.8702L215.596 66.1373C216.358 65.9533 216.954 65.3582 217.138 64.5959L218.87 57.4171Z"
        fill="url(#paint31_linear_5958_71186)"
      />
      <path
        d="M165.87 279.417C166.385 277.284 169.419 277.284 169.934 279.417L171.667 286.596C171.851 287.358 172.446 287.953 173.208 288.137L180.387 289.87C182.52 290.385 182.52 293.419 180.387 293.934L173.208 295.667C172.446 295.851 171.851 296.446 171.667 297.208L169.934 304.387C169.419 306.52 166.385 306.52 165.87 304.387L164.138 297.208C163.954 296.446 163.358 295.851 162.596 295.667L155.417 293.934C153.284 293.419 153.284 290.385 155.417 289.87L162.596 288.137C163.358 287.953 163.954 287.358 164.138 286.596L165.87 279.417Z"
        fill="url(#paint32_linear_5958_71186)"
      />
      <g filter="url(#filter4_dd_5958_71186)">
        <ellipse
          cx="196.668"
          cy="195.28"
          rx="4.84914"
          ry="5.28017"
          fill="#0368BD"
        />
        <path
          d="M207.336 207.996C207.336 207.076 207.06 206.165 206.524 205.315C205.988 204.465 205.202 203.693 204.212 203.043C203.221 202.392 202.045 201.877 200.751 201.525C199.456 201.173 198.069 200.991 196.668 200.991C195.267 200.991 193.88 201.173 192.586 201.525C191.291 201.877 190.115 202.392 189.125 203.043C188.134 203.693 187.348 204.465 186.812 205.315C186.276 206.165 186 207.076 186 207.996L196.668 207.996H207.336Z"
          fill="#0368BD"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_5958_71186"
          x="93.2272"
          y="223.227"
          width="264.76"
          height="86.221"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.8865"
            result="effect1_foregroundBlur_5958_71186"
          />
        </filter>
        <filter
          id="filter1_d_5958_71186"
          x="115.152"
          y="135.327"
          width="68.5914"
          height="76.5433"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="6.64476" dy="10.4418" />
          <feGaussianBlur stdDeviation="4.74626" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.184314 0 0 0 0 0.254902 0 0 0 0 0.443137 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5958_71186"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5958_71186"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_5958_71186"
          x="273.678"
          y="116.342"
          width="68.5914"
          height="76.5433"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="6.64476" dy="10.4418" />
          <feGaussianBlur stdDeviation="4.74626" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.184314 0 0 0 0 0.254902 0 0 0 0 0.443137 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5958_71186"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5958_71186"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_f_5958_71186"
          x="96.2272"
          y="101.227"
          width="116.703"
          height="67.0609"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.8865"
            result="effect1_foregroundBlur_5958_71186"
          />
        </filter>
        <filter
          id="filter4_dd_5958_71186"
          x="167"
          y="171"
          width="59.3362"
          height="55.9956"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.409836 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5958_71186"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.411765 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_5958_71186"
            result="effect2_dropShadow_5958_71186"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_5958_71186"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_5958_71186"
          x1="228.817"
          y1="25.6505"
          x2="231.167"
          y2="428.463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CAE0FF" stopOpacity="0" />
          <stop offset="1" stopColor="#BCD8FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5958_71186"
          x1="245.588"
          y1="109.366"
          x2="245.588"
          y2="181.262"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCCFF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5958_71186"
          x1="343.716"
          y1="109.366"
          x2="343.716"
          y2="181.254"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70A8FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5958_71186"
          x1="365.28"
          y1="172.348"
          x2="333.005"
          y2="129.631"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_5958_71186"
          x1="251.705"
          y1="121.432"
          x2="251.705"
          y2="181.262"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#6095E7" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_5958_71186"
          x1="206.755"
          y1="288.156"
          x2="140.307"
          y2="225.506"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_5958_71186"
          x1="261.337"
          y1="268.697"
          x2="194.89"
          y2="241.168"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_5958_71186"
          x1="320.191"
          y1="270.121"
          x2="258.49"
          y2="211.742"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_5958_71186"
          x1="312.214"
          y1="109.366"
          x2="312.214"
          y2="181.262"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCCFF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_5958_71186"
          x1="176.854"
          y1="209.843"
          x2="168.31"
          y2="292.903"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCCFF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_5958_71186"
          x1="123.221"
          y1="197.503"
          x2="258.964"
          y2="260.154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCCFF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_5958_71186"
          x1="365.28"
          y1="239.27"
          x2="280.322"
          y2="242.118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70A8FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_5958_71186"
          x1="199.979"
          y1="181.415"
          x2="199.979"
          y2="216.978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70A8FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_5958_71186"
          x1="196.973"
          y1="181.415"
          x2="196.973"
          y2="216.978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCCFF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_5958_71186"
          x1="196.977"
          y1="184.819"
          x2="196.977"
          y2="213.286"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70A8FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_5958_71186"
          x1="162.223"
          y1="160.521"
          x2="128.823"
          y2="157.186"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6DDFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_5958_71186"
          x1="281.909"
          y1="141.535"
          x2="315.309"
          y2="138.201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6DDFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_5958_71186"
          x1="122.179"
          y1="145.544"
          x2="122.179"
          y2="157.347"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_5958_71186"
          x1="321.953"
          y1="126.559"
          x2="321.953"
          y2="138.362"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_5958_71186"
          x1="235.038"
          y1="91"
          x2="235.038"
          y2="181.025"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_5958_71186"
          x1="271.305"
          y1="113.969"
          x2="252.794"
          y2="99.7299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_5958_71186"
          x1="108.508"
          y1="259.204"
          x2="198.363"
          y2="249.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.09375" stopColor="#0088FA" />
          <stop offset="1" stopColor="#2A64BE" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_5958_71186"
          x1="177.803"
          y1="260.342"
          x2="256.859"
          y2="248.336"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.09375" stopColor="#0088FA" />
          <stop offset="1" stopColor="#2A64BE" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_5958_71186"
          x1="240.929"
          y1="259.204"
          x2="314.57"
          y2="265.666"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.09375" stopColor="#0088FA" />
          <stop offset="1" stopColor="#84B4FF" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_5958_71186"
          x1="120.304"
          y1="86.2325"
          x2="182.98"
          y2="145.636"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF698D" />
          <stop offset="1" stopColor="#FF3868" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_5958_71186"
          x1="297"
          y1="95.0964"
          x2="309.193"
          y2="95.0964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_5958_71186"
          x1="297"
          y1="95.0964"
          x2="309.193"
          y2="95.0964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_5958_71186"
          x1="269"
          y1="286.096"
          x2="281.193"
          y2="286.096"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_5958_71186"
          x1="267.603"
          y1="282.286"
          x2="286.655"
          y2="298.797"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94BFFF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_5958_71186"
          x1="104.759"
          y1="222.492"
          x2="115.744"
          y2="236.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_5958_71186"
          x1="334.083"
          y1="226.399"
          x2="346.549"
          y2="214.233"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_5958_71186"
          x1="200"
          y1="69.9021"
          x2="241.804"
          y2="69.9021"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_5958_71186"
          x1="147"
          y1="291.902"
          x2="188.804"
          y2="291.902"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function AddUserIcon({ color, width, height }) {
  return (
    <svg
      width={width !== '' ? width : '14'}
      height={height !== '' ? height : '15'}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33333 9.50132V10.8947C6.72994 10.6813 6.08418 10.6159 5.45027 10.7038C4.81635 10.7918 4.2128 11.0306 3.69028 11.4001C3.16777 11.7697 2.74156 12.2592 2.44744 12.8276C2.15332 13.396 1.99988 14.0267 2 14.6667L0.666664 14.666C0.666457 13.8519 0.852612 13.0486 1.21086 12.3176C1.56911 11.5866 2.08996 10.9473 2.73348 10.4487C3.377 9.95008 4.12611 9.60541 4.92343 9.44109C5.72075 9.27676 6.5451 9.29714 7.33333 9.50066V9.50132ZM6 8.66666C3.79 8.66666 2 6.87666 2 4.66666C2 2.45666 3.79 0.666656 6 0.666656C8.21 0.666656 10 2.45666 10 4.66666C10 6.87666 8.21 8.66666 6 8.66666ZM6 7.33332C7.47333 7.33332 8.66666 6.13999 8.66666 4.66666C8.66666 3.19332 7.47333 1.99999 6 1.99999C4.52666 1.99999 3.33333 3.19332 3.33333 4.66666C3.33333 6.13999 4.52666 7.33332 6 7.33332ZM10 11.3333V9.33332H11.3333V11.3333H13.3333V12.6667H11.3333V14.6667H10V12.6667H8V11.3333H10Z"
        fill={color !== '' ? color : 'white'}
      />
    </svg>
  );
}
AddUserIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
AddUserIcon.defaultProps = {
  color: '',
  width: '',
  height: '',
};
export function AddUserNewCircleIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.64091 9.65291C6.33424 9.65291 5.26758 8.58625 5.26758 7.27958C5.26758 5.97292 6.33424 4.90625 7.64091 4.90625C8.94758 4.90625 10.0142 5.97292 10.0142 7.27958C10.0142 8.58625 8.94758 9.65291 7.64091 9.65291ZM7.64091 5.91292C6.88758 5.91292 6.26758 6.52625 6.26758 7.28625C6.26758 8.04625 6.88091 8.65959 7.64091 8.65959C8.40091 8.65959 9.01424 8.04625 9.01424 7.28625C9.01424 6.52625 8.40091 5.91292 7.64091 5.91292Z"
        fill={color}
      />
      <path
        d="M11.0997 13.9665C10.8264 13.9665 10.5997 13.7398 10.5997 13.4665C10.5997 12.1865 9.27302 11.1465 7.63969 11.1465C6.00635 11.1465 4.67969 12.1865 4.67969 13.4665C4.67969 13.7398 4.45302 13.9665 4.17969 13.9665C3.90635 13.9665 3.67969 13.7398 3.67969 13.4665C3.67969 11.6398 5.45302 10.1465 7.63969 10.1465C9.82635 10.1465 11.5997 11.6332 11.5997 13.4665C11.5997 13.7398 11.373 13.9665 11.0997 13.9665Z"
        fill={color}
      />
      <path
        d="M7.66732 15.1667C3.90065 15.1667 0.833984 12.1 0.833984 8.33333C0.833984 4.56667 3.90065 1.5 7.66732 1.5C8.59398 1.5 9.48732 1.67999 10.3273 2.03333C10.5673 2.13333 10.6873 2.39998 10.6073 2.64665C10.534 2.86665 10.5007 3.1 10.5007 3.33333C10.5007 3.72667 10.6073 4.11332 10.814 4.44666C10.9207 4.63332 11.0607 4.79998 11.2207 4.93998C11.8007 5.46665 12.6607 5.63335 13.334 5.39335C13.5807 5.30002 13.8607 5.42667 13.9607 5.67334C14.3207 6.52001 14.5007 7.42001 14.5007 8.34001C14.5007 12.1 11.434 15.1667 7.66732 15.1667ZM7.66732 2.5C4.45398 2.5 1.83398 5.11333 1.83398 8.33333C1.83398 11.5533 4.45398 14.1667 7.66732 14.1667C10.8807 14.1667 13.5007 11.5533 13.5007 8.33333C13.5007 7.69333 13.394 7.06 13.194 6.45333C12.274 6.61333 11.2673 6.32668 10.5607 5.68001C10.3273 5.48001 10.1207 5.23334 9.96065 4.96C9.66732 4.48 9.50732 3.91333 9.50732 3.33333C9.50732 3.15333 9.52065 2.98001 9.55399 2.80668C8.94732 2.60001 8.31398 2.5 7.66732 2.5Z"
        fill={color}
      />
      <path
        d="M12.6667 6.50033C11.88 6.50033 11.1333 6.20701 10.5533 5.68034C10.32 5.48034 10.1133 5.23366 9.95333 4.96033C9.66 4.48033 9.5 3.91366 9.5 3.33366C9.5 2.99366 9.55333 2.66033 9.66 2.34033C9.80667 1.887 10.06 1.46699 10.4 1.12699C11 0.51366 11.8067 0.166992 12.6733 0.166992C13.58 0.166992 14.44 0.55367 15.0267 1.22034C15.5467 1.80034 15.84 2.54699 15.84 3.33366C15.84 3.58699 15.8067 3.84032 15.74 4.08032C15.6733 4.38032 15.5467 4.69367 15.3733 4.967C14.9867 5.62033 14.3733 6.10699 13.6533 6.33366C13.3533 6.44699 13.02 6.50033 12.6667 6.50033ZM12.6667 1.16699C12.0733 1.16699 11.52 1.40031 11.1133 1.82031C10.88 2.06031 10.7133 2.33364 10.6133 2.64697C10.54 2.86697 10.5067 3.10033 10.5067 3.33366C10.5067 3.72699 10.6133 4.11365 10.82 4.44698C10.9267 4.63365 11.0667 4.80031 11.2267 4.94031C11.8067 5.46697 12.6667 5.63368 13.34 5.39368C13.8467 5.23368 14.26 4.90032 14.5267 4.45365C14.6467 4.26032 14.7267 4.05367 14.7733 3.84701C14.82 3.67367 14.84 3.50699 14.84 3.33366C14.84 2.80033 14.64 2.287 14.28 1.887C13.8733 1.427 13.2867 1.16699 12.6667 1.16699Z"
        fill={color}
      />
      <path
        d="M13.6593 3.82031H11.666C11.3927 3.82031 11.166 3.59365 11.166 3.32031C11.166 3.04698 11.3927 2.82031 11.666 2.82031H13.6593C13.9327 2.82031 14.1593 3.04698 14.1593 3.32031C14.1593 3.59365 13.9393 3.82031 13.6593 3.82031Z"
        fill={color}
      />
      <path
        d="M12.666 4.84001C12.3927 4.84001 12.166 4.61334 12.166 4.34001V2.34668C12.166 2.07335 12.3927 1.84668 12.666 1.84668C12.9393 1.84668 13.166 2.07335 13.166 2.34668V4.34001C13.166 4.62001 12.9393 4.84001 12.666 4.84001Z"
        fill={color}
      />
    </svg>
  );
}
AddUserNewCircleIcon.propTypes = {
  color: PropTypes.string,
};
AddUserNewCircleIcon.defaultProps = {
  color: '#395C85',
};
export function EmailIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.636 5.04492H19.363C20.267 5.04492 21 5.77792 21 6.68192V17.3179C21 18.2219 20.267 18.9539 19.364 18.9539H4.636C3.733 18.9549 3 18.2219 3 17.3179V6.68192C3 5.77792 3.733 5.04492 4.636 5.04492Z"
        stroke={color !== '' ? color : '#828282'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.11914 6.07504L10.8131 11.578C11.5081 12.075 12.4421 12.076 13.1381 11.58L20.8761 6.06104"
        stroke={color !== '' ? color : '#828282'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
EmailIcon.propTypes = {
  color: PropTypes.string,
};
EmailIcon.defaultProps = {
  color: '',
};
export function LocationOutlined({ margin, color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin }}
    >
      <path
        d="M7.00018 8.766C5.75768 8.766 4.74268 7.75684 4.74268 6.5085C4.74268 5.26017 5.75768 4.25684 7.00018 4.25684C8.24268 4.25684 9.25768 5.266 9.25768 6.51434C9.25768 7.76267 8.24268 8.766 7.00018 8.766ZM7.00018 5.13184C6.24184 5.13184 5.61768 5.75017 5.61768 6.51434C5.61768 7.2785 6.23601 7.89684 7.00018 7.89684C7.76434 7.89684 8.38268 7.2785 8.38268 6.51434C8.38268 5.75017 7.75851 5.13184 7.00018 5.13184Z"
        fill={color}
      />
      <path
        d="M6.99998 13.777C6.13665 13.777 5.26748 13.4503 4.59081 12.8028C2.86998 11.1462 0.968314 8.50366 1.68581 5.35949C2.33331 2.50699 4.82415 1.22949 6.99998 1.22949C6.99998 1.22949 6.99998 1.22949 7.00581 1.22949C9.18165 1.22949 11.6725 2.50699 12.32 5.36533C13.0316 8.50949 11.13 11.1462 9.40915 12.8028C8.73248 13.4503 7.86331 13.777 6.99998 13.777ZM6.99998 2.10449C5.30248 2.10449 3.12081 3.00866 2.54331 5.55199C1.91331 8.29949 3.63998 10.6678 5.20331 12.167C6.21248 13.1412 7.79331 13.1412 8.80248 12.167C10.36 10.6678 12.0866 8.29949 11.4683 5.55199C10.885 3.00866 8.69748 2.10449 6.99998 2.10449Z"
        fill={color}
      />
    </svg>
  );
}
LocationOutlined.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  margin: PropTypes.string,
};
LocationOutlined.defaultProps = {
  color: '#ffffff',
  size: '1.042vw',
  margin: '0',
};
export function NameIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM7.013 18.256C8.42855 19.3877 10.1877 20.0029 12 20C13.97 20 15.773 19.288 17.167 18.108C16.5157 17.4397 15.7371 16.9089 14.877 16.5468C14.017 16.1847 13.0931 15.9988 12.16 16C11.1926 15.9989 10.2355 16.1989 9.34947 16.5872C8.46343 16.9756 7.66778 17.5439 7.013 18.256ZM5.616 16.82C6.45645 15.9281 7.47067 15.2177 8.59614 14.7327C9.72161 14.2477 10.9345 13.9984 12.16 14C13.3417 13.9985 14.512 14.2304 15.6037 14.6824C16.6955 15.1344 17.6873 15.7976 18.522 16.634C19.3781 15.4291 19.8836 14.0106 19.9826 12.5359C20.0815 11.0612 19.77 9.58789 19.0825 8.27946C18.395 6.97102 17.3585 5.87862 16.088 5.12345C14.8174 4.36827 13.3625 3.97984 11.8846 4.00125C10.4067 4.02267 8.96366 4.45308 7.71552 5.24476C6.46738 6.03643 5.46296 7.1584 4.81369 8.4862C4.16442 9.814 3.89569 11.2957 4.03732 12.7669C4.17894 14.2382 4.72537 15.6414 5.616 16.821V16.82ZM12 13C10.9391 13 9.92172 12.5786 9.17157 11.8284C8.42143 11.0783 8 10.0609 8 9C8 7.93913 8.42143 6.92172 9.17157 6.17157C9.92172 5.42143 10.9391 5 12 5C13.0609 5 14.0783 5.42143 14.8284 6.17157C15.5786 6.92172 16 7.93913 16 9C16 10.0609 15.5786 11.0783 14.8284 11.8284C14.0783 12.5786 13.0609 13 12 13ZM12 11C12.5304 11 13.0391 10.7893 13.4142 10.4142C13.7893 10.0391 14 9.53043 14 9C14 8.46957 13.7893 7.96086 13.4142 7.58579C13.0391 7.21071 12.5304 7 12 7C11.4696 7 10.9609 7.21071 10.5858 7.58579C10.2107 7.96086 10 8.46957 10 9C10 9.53043 10.2107 10.0391 10.5858 10.4142C10.9609 10.7893 11.4696 11 12 11Z"
        fill={color !== '' ? color : '#A6A6A6'}
      />
    </svg>
  );
}
NameIcon.propTypes = {
  color: PropTypes.string,
};
NameIcon.defaultProps = {
  color: '',
};
export function DollerIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.67188 14.3298C8.67188 15.6198 9.66188 16.6598 10.8919 16.6598H13.4019C14.4719 16.6598 15.3419 15.7498 15.3419 14.6298C15.3419 13.4098 14.8119 12.9798 14.0219 12.6998L9.99187 11.2998C9.20187 11.0198 8.67188 10.5898 8.67188 9.36984C8.67188 8.24984 9.54187 7.33984 10.6119 7.33984H13.1219C14.3519 7.33984 15.3419 8.37984 15.3419 9.66984"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6V18"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
DollerIcon.propTypes = {
  color: PropTypes.string,
};
DollerIcon.defaultProps = {
  color: '#292D32',
};
export function WarningIconConnect() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7605 15.92L15.3605 4.4C14.5005 2.85 13.3105 2 12.0005 2C10.6905 2 9.50047 2.85 8.64047 4.4L2.24047 15.92C1.43047 17.39 1.34047 18.8 1.99047 19.91C2.64047 21.02 3.92047 21.63 5.60047 21.63H18.4005C20.0805 21.63 21.3605 21.02 22.0105 19.91C22.6605 18.8 22.5705 17.38 21.7605 15.92ZM11.2505 9C11.2505 8.59 11.5905 8.25 12.0005 8.25C12.4105 8.25 12.7505 8.59 12.7505 9V14C12.7505 14.41 12.4105 14.75 12.0005 14.75C11.5905 14.75 11.2505 14.41 11.2505 14V9ZM12.7105 17.71C12.6605 17.75 12.6105 17.79 12.5605 17.83C12.5005 17.87 12.4405 17.9 12.3805 17.92C12.3205 17.95 12.2605 17.97 12.1905 17.98C12.1305 17.99 12.0605 18 12.0005 18C11.9405 18 11.8705 17.99 11.8005 17.98C11.7405 17.97 11.6805 17.95 11.6205 17.92C11.5605 17.9 11.5005 17.87 11.4405 17.83C11.3905 17.79 11.3405 17.75 11.2905 17.71C11.1105 17.52 11.0005 17.26 11.0005 17C11.0005 16.74 11.1105 16.48 11.2905 16.29C11.3405 16.25 11.3905 16.21 11.4405 16.17C11.5005 16.13 11.5605 16.1 11.6205 16.08C11.6805 16.05 11.7405 16.03 11.8005 16.02C11.9305 15.99 12.0705 15.99 12.1905 16.02C12.2605 16.03 12.3205 16.05 12.3805 16.08C12.4405 16.1 12.5005 16.13 12.5605 16.17C12.6105 16.21 12.6605 16.25 12.7105 16.29C12.8905 16.48 13.0005 16.74 13.0005 17C13.0005 17.26 12.8905 17.52 12.7105 17.71Z"
        fill="#F2C94C"
      />
    </svg>
  );
}
export function CloseIcon({ color, size }) {
  return (
    <svg
      width={size !== '' ? size : '2.083vw'}
      height={size !== '' ? size : '2.083vw'}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 15.4379L24.7188 8.21917L26.7808 10.2813L19.5621 17.5L26.7808 24.7188L24.7188 26.7808L17.5 19.5621L10.2813 26.7808L8.21918 24.7188L15.4379 17.5L8.21918 10.2813L10.2813 8.21917L17.5 15.4379Z"
        fill={color !== '' ? color : '#828282'}
      />
    </svg>
  );
}
CloseIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
CloseIcon.defaultProps = {
  color: '',
  size: '',
};
